// extracted by mini-css-extract-plugin
module.exports = {"login":"SignIn_login__21LAx","loginLogo":"SignIn_loginLogo__2tc8d","btnColor":"SignIn_btnColor__A4o3g","forgotPW":"SignIn_forgotPW__EBUhA","shadow":"SignIn_shadow__DK2gV"};